import { useEffect, useState } from 'react';
import {
    PanelBody,
    Button,
    Modal,
    TextControl,
    SelectControl,
    TextareaControl,
    CheckboxControl,
    __experimentalNumberControl as NumberControl,
    Spinner,
    ColorPalette,
    RangeControl,
    __experimentalText as Text
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { fetchData, saveData } from './api';
const LayoutTab = ({ openPopup , setActiveTab }) => {
    const [isSaving, setIsSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [modifiedFields, setModifiedFields] = useState({});
    useEffect(() => {
        // Fetch settings from the REST API
        fetchData(gmwcp_wp_ajax.getsettings, gmwcp_wp_ajax.nonce)
            .then((fetchedData) => {
                setData(fetchedData);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching settings:', error);
            });
    }, []);

    const updateField = (field, value) => {
        setData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
        setModifiedFields((prevFields) => ({
            ...prevFields,
            [field]: value,
        }));
    };
    const toggleCheckbox = (fieldName, key) => {
        setData((prevData) => {
            const currentValues = prevData[fieldName] || [];
            const updatedValues = currentValues.includes(key)
                ? currentValues.filter((item) => item !== key) // Remove key if already present
                : [...currentValues, key]; // Add key if not present
            return {
                ...prevData,
                [fieldName]: updatedValues,
            };
        });
        setModifiedFields((prevFields) => ({
            ...prevFields,
            [fieldName]: data[fieldName]?.includes(key)
                ? data[fieldName].filter((item) => item !== key)
                : [...(data[fieldName] || []), key],
        }));
    };

    const saveSettings = () => {
        if (Object.keys(modifiedFields).length === 0) {
            openPopup('No changes to save.');
            return;
        }
        setIsSaving(true);

        saveData(gmwcp_wp_ajax.savedata, gmwcp_wp_ajax.nonce, modifiedFields)
            .then((responseData) => {
                setIsSaving(false);
                if (responseData.success) {
                    openPopup('Settings saved!');
                    setModifiedFields({});
                } else {
                    openPopup('Failed to save settings.');
                }
            })
            .catch((error) => {
                setIsSaving(false);
                console.error('Error saving settings:', error);
                openPopup('Failed to save settings.');
            });
    };
    return (
        <PanelBody>
         {loading ? (
                <Spinner />
            ) : (
                <>
          <table className="GMadminTable">
                            <tr>
                                <th>
                                    <label>Header Text</label>
                                </th>
                                <td>
                                     <TextareaControl
                         onChange={(value) => updateField('gmptp_header_text', value)}
                                    value={data.gmptp_header_text}
                                    disabled
                      />
                      <div><a href="https://www.codesmade.com/store/post-to-pdf-pro/" target="_blank">Get Pro Version</a></div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Footer Text</label>
                                </th>
                                <td>
                                     <TextareaControl
                         onChange={(value) => updateField('gmptp_footer_text', value)}
                                    value={data.gmptp_footer_text}
                                    disabled
                      />
                      <div><a href="https://www.codesmade.com/store/post-to-pdf-pro/" target="_blank">Get Pro Version</a></div>
                                </td>
                            </tr>
                              <tr>
                                <th>
                                    <label>Background Color</label>
                                </th>
                                <td>
                                     <ColorPalette
                         onChange={(value) => updateField('gmptp_background_color', value)}
                                    value={data.gmptp_background_color}
                      />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Text Color</label>
                                </th>
                                <td>
                                     <ColorPalette
                         onChange={(value) => updateField('gmptp_text_color', value)}
                                    value={data.gmptp_text_color}
                      />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Header/Footer Background Color</label>
                                </th>
                                <td>
                                     <ColorPalette
                         onChange={(value) => updateField('gmptp_hf_background_color', value)}
                                    value={data.gmptp_hf_background_color}
                      />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Header/Footer Text Color</label>
                                </th>
                                <td>
                                     <ColorPalette
                         onChange={(value) => updateField('gmptp_hf_text_color', value)}
                                    value={data.gmptp_hf_text_color}
                      />
                                </td>
                            </tr>

                             <tr>
                                <th>
                                    <label>Download Button Background Color</label>
                                </th>
                                <td>
                                     <ColorPalette
                         onChange={(value) => updateField('gmptp_button_background_color', value)}
                                    value={data.gmptp_button_background_color}
                      />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Download Button Text Color</label>
                                </th>
                                <td>
                                     <ColorPalette
                         onChange={(value) => updateField('gmptp_button_text_color', value)}
                                    value={data.gmptp_button_text_color}
                      />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Title Font Size</label>
                                </th>
                                <td>
                                   <NumberControl
                            
                                    help="Enter Number Title Font Size"
                                    onChange={(value) => updateField('gmptp_product_title_font_size', value)}
                                    value={data.gmptp_product_title_font_size}
                                  />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Content Font Size</label>
                                </th>
                                <td>
                                   <NumberControl
                            
                                    help="Enter Number Content Font Size"
                                    onChange={(value) => updateField('gmptp_product_content_font_size', value)}
                                    value={data.gmptp_product_content_font_size}
                                  />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Image Size</label>
                                </th>
                                <td>
                                    <NumberControl
                                
                                        help="Enter Number  Image Size"
                                        onChange={(value) => updateField('gmptp_product_image_size', value)}
                                        value={data.gmptp_product_image_size}
                                      />
                                </td>
                            </tr>
                            
          </table>
                  <Button isPrimary onClick={saveSettings} disabled={isSaving}>
                            {isSaving ? <Spinner /> : 'Save Settings'}
                        </Button>
                 
                   </>
            )}
        </PanelBody>
    );
};

export default LayoutTab;
